import { Redirect, Switch, Route, useRouteMatch } from 'react-router-dom';
import SideMenuStandardization from '../../components/SideMenuStandardization';
import StandardizationProject from '../../components/StandardizationProject';
import { ScreenWrapper, ScrollerWrapper } from '../../styles/common';
import { detailsBackground } from '../../config/colors';

const StandardizationScreen = () => {
  const { path } = useRouteMatch();

  return (
    <ScreenWrapper>
      <ScrollerWrapper background={detailsBackground}>
        <Switch>
          <Route
            exact
            path={`${path}`}
            component={() => <SideMenuStandardization />}
          />
          <Route
            exact
            path={`${path}/project/:projectId`}
            component={() => <StandardizationProject />}
          />
          <Redirect
            path='*'
            to={path}
          />
        </Switch>
      </ScrollerWrapper>
    </ScreenWrapper>
  );
};

const StandardizationScreenWrapped = () => <StandardizationScreen />;

export default StandardizationScreenWrapped;
